import React, { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../contexts/UserContext';

const GerantProtectedRoute = ({ children }) => {
    const { gerant, loading } = useContext(UserContext);
    const navigate = useNavigate();
    useEffect(() => {
        if (loading) {
            // Ne rien faire tant que le chargement est en cours
            return;
        }

        if (gerant && gerant.role === 'LS4g9ZSMHtmQjG0vTDLa') {
            // L'utilisateur est authentifié avec le bon rôle
        } else if (gerant) {
            console.log('Rôle incorrect, redirection vers /accessDenied');
            navigate('/accessDenied'); // Rediriger si rôle incorrect
        } else {
            console.log('Non authentifié, redirection vers /login');
            navigate('/login'); // Rediriger vers la page de login si non authentifié
        }
    }, [gerant, loading, navigate]);

 

    // Afficher un chargement tant que la redirection n'est pas faite
    if (gerant === null) {
        navigate('/login');
    }

    return children;
};

export default GerantProtectedRoute;
